import React from 'react';
import Calendar from "./Calendar";
import {withRouter} from "react-router-dom";
import {Card, CardBody, CardHeader, Collapse} from "reactstrap";
import * as innerRoutes from "../../innerRoutes";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";

class WorkSpaceCalender extends React.Component {

  state = {
    workspace_obj: null,
    workspace: "",
    date: null
  };

  navSlotView = ( reservationData, date ) => {

    this.props.reservationHandler(reservationData);
    this.props.reservetionDateHandler(date);

    this.navSlotView_();

  };

  navSlotView_ = () => {
    this.props.history.push(innerRoutes.inner_route_spacetags_workspace_calender_slots);
  };


  componentDidMount() {

    if(this.props.workspace !== null) {
      let description = this.props.workspace.description;
      let branch = this.props.workspace.branch.name;
      let building = this.props.workspace.building.name;
      let floor = this.props.workspace.floor.description;

      this.setState({
        workspace: " " + description + "/ " + floor + "/ " + building + "/ " + branch,
        workspace_obj: this.props.workspace,
        date: null
      });
    } else {
      this.props.history.push(innerRoutes.inner_route_spacetags_all_workspace);
    }
  }

  render() {

    return(
      <div>
        <Card>
          <CardHeader>
            Work Space Calendar
          </CardHeader>
          <Collapse isOpen={true} id="collapseExample">
            <CardBody>
              <div className={'ws_details'}>
                <table>
                  <tbody>
                  <tr>
                    <td className={'sub-header'}>Work Space</td>
                    <td>:
                      { this.state.workspace }
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <Calendar goSlotView={ this.navSlotView } data={ this.props.workspace } date = { this.state.date }/>
              </div>
            </CardBody>
          </Collapse>
        </Card>
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  workspace: state.workspaceReducer.workspace
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    reservationHandler: (data) => dispatch(actionCreator.workspaceSaveReservationsHandler(data)),
    reservationRemoveHandler: () => dispatch(actionCreator.workspaceRemoveReservationsHandler()),
    reservetionDateHandler: (data) => dispatch(actionCreator.reservetionDateHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WorkSpaceCalender));
